import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack, IconClose } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { ActionBarHeader } from './ActionBarHeader';
import { InAppActionBar } from './InAppActionBar';
const TitleActionBar = ({ testID, title, closeBtn, onBack }) => {
    const isLibre = store.getState().env.app === 'libre1';
    if (isLibre) {
        return React.createElement(InAppActionBar, { title: title, testID: testID, onBack: onBack });
    }
    return (React.createElement(VStack, { style: {
            top: 0,
            left: 0,
            right: 0,
        }, backgroundColor: "$surface.container" },
        React.createElement(ActionBarHeader, { testID: testID }),
        React.createElement(HStack, { padding: "$4" },
            React.createElement(IconButton, { testID: `${testID}.back-btn`, onPress: () => {
                    onBack ? onBack() : mediator.publish('router:back');
                } }, closeBtn ? (React.createElement(IconClose, { testID: `${testID}.close-btn-icon` })) : (React.createElement(IconBack, { testID: `${testID}.back-btn-icon` }))),
            React.createElement(Text, { testID: `${testID}.title`, color: "$text.100", fontSize: "$h4.strong", fontWeight: "$h4.strong", width: "100%", alignSelf: "center", textAlign: "center", numberOfLines: 1 }, title))));
};
export { TitleActionBar };
